<template>
  <Icon
    class="text-gray-400 dark:text-gray-500 ml-1"
    :solid="true"
    type="external-link"
    width="18"
  />
</template>
